import React from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Hero from '../components/Hero';
import banner1 from '../assets/Automaticbanner.png'
import banner2 from '../assets/ceramicbanner.jpg'
import banner3 from '../assets/Graphenebanner.png'
import banner4 from '../assets/borophenebanner.png'
import banner5 from '../assets/paintbanner.png'
import banner6 from '../assets/windbanner.png'
import banner7 from '../assets/spraybanner.png'
import banner8 from '../assets/detailingbanner.png'
import banner9 from '../assets/deepbanner.png'
import banner10 from '../assets/steambanner.jpg'
import banner11 from '../assets/bikebanner.png'
import banner12 from '../assets/windowbanner.png'
import banner13 from '../assets/paintbanner.png'
import banner14 from '../assets/carbanner.png'
import SubServiceHero from '../components/SubServiceHero';
import OurWorks from '../components/OurWorks';
import MembershipQuoteForm from '../components/MembershipQuoteForm';
import FaqSection from '../components/FaqSection';
import { Helmet } from "react-helmet";

// Example: Map slugs to meta info
const serviceMeta = {
  "automatic-car-wash": {
    title: "Advanced Touchless Car Wash Machines| Drive-in Car Spa",
    description: "Find fully automatic car wash machines near you for quick and efficient vehicle cleaning. Experience modern technology for safe car washing.",
    keywords: "fully automatic car wash machine near me, Automatic Car Wash Near Me, Touchless Automatic Car Wash, Professional Automatic Car Cleaning Services, Drive-Through Car Wash Service, Automatic Car Wash Machine Cleaning"
  },
  "ceramic-coating": {
    title: "Ceramic Coating Near me In Bangalore | Drive-in Car Spa",
    description: "Protect your car with expert ceramic coating in Bangalore. Get long-lasting shine, durability, and the best ceramic coating for cars price in Bangalore today.",
    keywords: "best ceramic coating services near me, Car Ceramic Coating Services, Nano Ceramic Coating Protection, ing Car Paint Protection, Professional Ceramic Coating, Bangalore, Car Paint Protection Coating"
  },
  "graphene-coating": {
    title: "Graphene & Borophene Coating Near Me | Drive-in Car Spa",
    description: "Protect your car with the best graphene coating for cars. Get superior durability, scratch resistance, and a long-lasting glossy finish. Book now for advanced paint protection.",
    keywords: "Best Graphene Coating for Cars, Graphene Coating Services Near Me, Professional Graphene Car Detailing, Long-Lasting Car Paint Protection Coating, Premium Graphene Coating for Cars, Car Graphene Coating in Bangalore"
  },
  "borophene-coating": {
    title: " Premium Borophene Car Coating  | Drive-in Car Spa",
    description: " Looking for the best borophene coating for cars? Protect your vehicle with next-gen technology offering high gloss, water resistance, and long-term paint protection. Book now.",
    keywords: "Best Borophene Coating for Cars, Car Spa Services With Borophene Coating, Borophene Paint Protection for Cars, Advanced Borophene Coating for Vehicles, Nano Borophene Coating for Car Paint Protection, Premium Borophene Coating Services"
  },
  "paint-protection-film": {
    title: "Affordable Protection & Best Deals | Drive-in Car Spa",
    description: "Looking for PPF car coating price near you? Get affordable paint protection film with scratch resistance, long-lasting durability, and a premium finish. Book your service today. ",
    keywords: "PPF Car Coating Price Near Me,Paint Protection Film, Clear Paint Protection Film Installation, Premium PPF Coating Services, Scratch Protection Film for Cars, Car PPF Installation Services"
  },
  "windshield-protection-film": {
    title: " Top Car Windshield Protection Films for Maximum Safety & Clarity | Drive-in Car Spa",
    description: "Looking for the best car windshield protection film? Explore top-rated films that offer superior impact resistance, optical clarity, and durability to keep your windshield safe and damage-free. ",
    keywords: " best Car Windshield Protection Film, windshield protection film, windshield protection film near me, windshield protection film price, car windshield protection film cost"
  },
  "sprayable-ppf": {
    title: "Best Sprayable Paint Protection Film | Drive-in Car Spa",
    description: "Discover the benefits of sprayable paint protection film for cars. Get seamless coverage, enhanced durability, and long-lasting shine while protecting your vehicle from scratches and damage.",
    keywords: "Sprayable Paint Protection Film, peelable spray paint, paint protection film, automatic car washing centre, best PPF coating near me"
  },
  "detailing-services": {
    title: "Find Top Car Detailing Near Me | Premium Car Wash Services | Drive-in Car Spa",
    description: "Searching for the best car wash near me? Discover professional detailing services offering deep cleaning, stain removal, and a high-gloss finish.",
    keywords: "top detailed car washing near me, car detailing Bengaluru, full service car cleaning near me, detailed car washing near me, drive-in car wash near me."
  },
  "deep-interior-cleaning": {
    title: " Best Car Cleaning Services in Bangalore | Book Expert Car Wash | Drive-in Car Spa",
    description: "Book the best car cleaning services in Bangalore. Enjoy deep cleaning, stain removal, and a showroom-like finish from reliable, affordable experts.",
    keywords: "Car cleaning services in Bangalore, Best car interior cleaning in Bangalore, car interior cleaning services, express automatic car wash, Car interior cleaning  near me"
  },
  "steam-wash": {
    title: "Professional Steam Car Wash Near Me | Interior & Exterior Cleaning | Drive-in Car Spa",
    description: " Searching for steam car cleaning near me? Discover professional services offering quick, safe, and water-efficient car washing solutions.",
    keywords: " steam car wash services near me, steam car wash cleaning,  best steam car wash, popular steam car washing services, popular Steam Car Washing Services"
  },
  "bike-detailing": {
    title: " Best Bike Detailing Services Near Me | Expert Motorcycle Cleaning | Drive-in Car Spa",
    description: "Discover top-rated bike detailing services near you. From deep cleaning to paint protection, keep your motorcycle shining like new. Book your service now!",
    keywords: " bike detailing Bengaluru,  Premium bike wash services,  full bike washing near me, ceramic coating for bike near me, best bike detailing services"
  },
  "window-films": {
    title: " Top Window Film Services | Premium Tinting & UV Protection | Drive-in Car Spa",
    description: "Discover premium window film services for better insulation, privacy, and sun protection. Professional tinting solutions for long-lasting performance.",
    keywords: "the car wash near me, best  Window Film services, car wash detailingin bangalore, premium Window Film services"
  },
  "painting-denting-services": {
    title: "Best Car Denting & Painting Services in Bangalore | Affordable | Drive-in Car Spa",
    description: "Restore your car’s look with expert denting and painting services in Bangalore: affordable pricing, precision work, and long-lasting shine. Get a free quote today!",
    keywords: "Best car denting and Painting in Bangalore, car denting and Painting near me, detailed car cleaning near me, car denting and Painting in Bangalore"
  },
  "car-modifications": {
    title: "Top Car Modification Services Near Me | Upgrade Your Ride | Drive-in Car Spa",
    description: "Transform your car with top car modification services near you. From interiors to performance upgrades, get professional customization at the best price.",
    keywords: "Best car accessories in India, Car modification services in India, Interior and exterior car customization, Premium Car in Bengaluru, Best Car Modification Near Me "
  },
};

const serviceData = {
  'automatic-car-wash': {
  hero: {
    title: (
      <>
        <span className="highlight">Fast, Touchless & Technologically  </span><br />
        Advanced
      </>
    ),
    subtitle: 'Touchless Car Wash That Shines Without Contact',
    bgImage: banner1,
    
  },
  maintitle: 'Automatic Car Wash (With Optional Hydrophobic Coating)',
  title: 'A Smarter, Safer Way to Clean Your Vehicle',
  description: 'Now see what cleaning a car in the future may look like: with automation, speed, safety, and shine in one place. Drive-In Car Spa offers an advanced fully automatic car wash machine near me experience with a fully touchless automatic car wash system, making us the best choice for professional automatic car cleaning services. Whether you are a car owner in need of a quick clean or a business looking at an automatic car wash for sale, our system delivers unmatched reliability and performance.',
  
  secondtitle: 'Why Choose a Machine Car Wash?',
  seconddescription: 'The days of bucket scrubs and long queues are over. A machine car wash is predictable, precise, and convenient, without exception. Our touchless automatic car wash system uses ultrasonic sensors, high-pressure water jets, rotating foam sprays, and an optional hydrophobic coating to guarantee a perfectly polished, scratch-free finish. Unlike other methods, this automatic car wash machine cleaning process uses only between 90 and 160L of water per car, making it eco-friendly while delivering superior results.',

  thirdtitle: 'Searching for "Automatic Car Wash Near Me"? We\'ve Got You Covered.',
  thirddescription: <>No matter how busy you are or if you are tired of waiting in line for inconsistent manual washes, our drive-through car wash service guarantees a superior solution. Our locations are clean, efficient, and optimized for customers searching for an <Link className='link-text' to="/">automatic car wash near me</Link> or fully automatic car wash machine near me. With minimal waiting time and easy-to-follow instructions, even first-time users can confidently experience our system.</>,

  fourthtitle: 'Hydrophobic Finish for Longer-Lasting Shine',
  fourthdescription: 'Want your car to stay cleaner for longer? The optional water-resistant finish includes a hydrophobic coating that enhances shine and reduces dust accumulation, water spots, and UV damage. It’s the perfect addition to our professional automatic car cleaning services, especially for Bangalore’s changing climate and dusty roads.',

  fivetitle: 'Automatic Car Wash Machine Price & Business Opportunities',
  fivedescription: 'Are you a service center, petrol pump owner, or entrepreneur searching for an automatic car wash for sale? Our Premium Plus channel partner program offers a smart investment opportunity in the growing demand for touchless automatic car wash and drive-through car wash service solutions. Key benefits include: Fully automated operations with no labor dependency, low running costs (20–50ml chemical usage per wash), water-efficient and recyclable systems, remote diagnostics with smart alerts, and complete support for branding, training, and setup.',

  sixtitle: 'The Future of Car Cleaning Starts Here',
  sixdescription: 'Experience the next generation of automatic car wash machine cleaning with Drive-In Car Spa. Whether you visit for a quick wash or invest in a fully automatic car wash machine near me, we deliver unmatched technology, care, and convenience. We are redefining professional automatic car cleaning services—one car at a time. Looking for a trusted automatic car wash near me? Your solution is here.',

  highlights: [
    'Underbody & Wheel Blast (80kg pressure)',
    'LAVA Foam Application',
    'Rotating Arm Jet Spray',
    'Hi-Gloss Shampoo Rinse',
    'Hydrophobic Coating (Optional Add-On)',
    'Turbo Drying System'
  ],

  faq: [
    {
      question: "How long does an automatic car wash take?",
      answer: "Typically, each cycle lasts 6 to 10 minutes, depending on service selections. It's faster than traditional washes with better consistency."
    },
    {
      question: "Will the machine scratch my car?",
      answer: "No. Our service is fully touchless and uses no brushes or physical contact. It's considered one of the best touchless automatic car wash systems in India."
    },
    {
      question: "Can I get a hydrophobic coating every time?",
      answer: "Yes, it's available as an optional add-on. It boosts shine and helps your car stay clean for longer."
    },
    {
      question: "Is the car wash machine available for sale?",
      answer: "Yes! We offer dealership and franchise packages. If you're comparing automatic car wash machine price or searching for an automatic car wash for sale, reach out to our team."
    },
    {
      question: "Can I visit without a booking?",
      answer: "Absolutely. Just search automatic car wash near me or drive-through car wash service near me and walk in—we are built for speed and convenience."
    },
  ],

  pillLabel: 'Key Highlights',
  audience: 'All Car Owners',
},


'ceramic-coating': {
  hero: {
    title: (
      <>
        <span className="highlight">Ceramic Coating for Cars in Bangalore </span><br />
        – Gloss, Protection, and Long-Term Value
      </>
    ),
    subtitle: 'Shield Your Paint With High-Performance Ceramic Coating',
    bgImage: banner2,
  },
  maintitle: 'Ceramic Coating',
  title: 'Upgrade Your Car\'s Finish with Advanced Ceramic Coating',
  description: <>When you want to find a long-lasting, high-gloss finish to protect your vehicle against wear and environmental damage that takes place in daily life, ceramic coating is the best choice. With advanced Nano Ceramic Coating Protection technology, Drive-In Car Spa offers one of the best ceramic coating services near me in Bangalore. Our <Link to="/" className="link-text">Car Ceramic Coating Services</Link> are designed to deliver long-lasting car paint protection, helping your vehicle withstand dust, rain, UV exposure, and pollutants. What makes us a favorite among those searching for professional ceramic coating Bangalore or automotive ceramic coating near me is our trained specialists, premium materials, and efficient service process.</>,

  secondtitle: 'What is Ceramic Coating and Why Does It Matter?',
  seconddescription: 'Ceramic coating is a clear, semi-permanent Car Paint Protection Coating applied over your vehicle’s paint surface. This nano ceramic coating protection forms a strong chemical bond with the car’s body, offering long-lasting car paint protection compared to traditional waxes or sealants. It protects against increased gloss & paint depth, water, dust, and road dirt, bird droppings, tree sap, oxidation, and UV rays, while also reducing the need for frequent washing and making cleaning easier.',

  thirdtitle: 'Ceramic Coating Price in Bangalore – What\'s Included?',
  thirddescription: 'We offer competitive pricing based on product quality and finish standards. When comparing car ceramic coating services near me or ceramic coating prices in Bangalore, it’s important to understand that we use industry-grade materials rather than off-the-shelf products. Our professional ceramic coating Bangalore solutions ensure superior durability, finish, and protection, making it a valuable investment for long-term car care.',

  fourthtitle: 'Why Ceramic Coating Is Ideal for Bangalore Drivers',
  fourthdescription: 'Bangalore’s roads and weather conditions can quickly affect your car’s appearance. With dust, pollution, monsoon splashes, and strong sunlight, your vehicle needs more than regular cleaning. Our nano ceramic coating protection creates a hydrophobic surface that repels water, dirt, and contaminants. This ensures long-lasting car paint protection, fewer washes, minimal scratches, and better color retention—making it ideal for anyone looking for reliable professional ceramic coating Bangalore services.',

  fivetitle: 'Automatic Car Wash Machine Price & Business Opportunities',
  fivedescription: 'Are you a service center, petrol pump owner, or an entrepreneur in need of an automatic car wash for sale? We have our channel partner program, Premium Plus we can offer. Here\'s why it\'s a smart investment: Fully automated, no labor required, Low running costs (20–50ml chemical usage per wash), Water efficient and optionally recyclable, Remote diagnostics and smart alerts, Support with branding, training, and setup',

  sixtitle: 'Is Ceramic Coating Worth It?',
  sixdescription: 'Professional ceramic coating is a smart investment for anyone who values long-term durability and aesthetics. It reduces swirl marks, resists chemical stains, and enhances resale value. Whether you want a showroom-like finish year-round or reliable car paint protection coating for daily driving conditions, our car ceramic coating services deliver lasting results.',

  highlights: [
    'Surface preparation and minor paint correction',
    'Two layers of nano-ceramic coating',
    'UV & chemical resistance',
    'Anti-water spot formulation',
    'Heat and oxidation protection',
    '0 free automatic car washes (valued add-on)',
    'Durability: 18–24 months (depending on usage)'
  ],

  faq: [
    {
      question: "What are the best ceramic coating services near me in Bangalore?",
      answer: "Drive-In Car Spa offers some of the best ceramic coating services near me with advanced nano ceramic coating protection, ensuring long-lasting car paint protection and premium finish."
    },
    {
      question: "What's the difference between ceramic coating and waxing?",
      answer: "Wax is temporary and provides minimal protection, whereas professional ceramic coating forms a durable chemical bond with your paint, offering superior nano ceramic coating protection and long-lasting car paint protection."
    },
    {
      question: "How long does ceramic coating last?",
      answer: "Typically between 18 to 24 months, depending on usage, driving conditions, and maintenance. Our car ceramic coating services are designed for durability and long-term performance."
    },
    {
      question: "Is ceramic coating good for Bangalore conditions?",
      answer: "Yes, ceramic coating Bangalore services are ideal for local conditions as they protect against dust, UV rays, pollution, and rain while maintaining shine and reducing maintenance."
    },
    {
      question: "Can I wash my car after ceramic coating?",
      answer: "Yes. Thanks to nano ceramic coating protection, cleaning becomes easier as dirt and water slide off the surface. It significantly reduces effort and frequency of washing."
    },
    {
      question: "How soon can I get it done?",
      answer: "Usually within a day. Visit us or book an appointment to experience professional ceramic coating Bangalore services trusted by car owners searching for car ceramic coating services near me."
    },
  ],

  pillLabel: 'Key Highlights',
  audience: 'All Car Owners',
},


'graphene-coating': {
  hero: {
    title: (
      <>
        <span className="highlight">Graphene Coating for Cars – Ultra-Durable,  </span><br />
        Anti-Static, and High Gloss Protection
      </>
    ),
    subtitle: 'Next-Level Paint Defense with Graphene Coating',
    bgImage: banner3,
  },
  maintitle: 'Graphene Coating',
  title: 'Level Up Your Car\'s Protection with Next-Gen Graphene Coating',
  description: <>With the evolution of car detailing, graphene coating has emerged as one of the best graphene coating for cars solutions available today. At Drive-In Car Spa, we offer <Link to="/" className="link-text">premium graphene coating for cars</Link> with professional graphene car detailing that delivers superior durability, anti-static properties, and extreme gloss. Whether you want to reduce heat, prevent water spots, or simplify maintenance, our car graphene coating in Bangalore is designed to deliver long-lasting car paint protection coating for modern driving conditions.</>,

  secondtitle: 'What is Graphene Coating & How Does It Work?',
  seconddescription: 'Graphene coating is a nanotechnology-based long-lasting car paint protection coating that forms a molecular bond with your vehicle’s paint. Made of carbon atoms arranged in a strong honeycomb structure, it creates an ultra-thin yet highly durable shield. Compared to traditional coatings, premium graphene coating for cars offers better resistance, flexibility, and longevity, making it a smart investment for anyone looking for graphene coating services near me.',

  thirdtitle: 'Why Choose Graphene Over Ceramic or Borophene Coating?',
  thirddescription: 'Lower surface temperature, reducing the risk of water spotting, Better chemical resistance and slickness, Stronger anti-static effect, meaning less dust buildup, Improved flexibility for better adhesion and fewer cracks over time. These benefits make professional graphene car detailing a superior choice for car owners who want advanced protection and easier maintenance.',

  fourthtitle: 'Why Graphene Coating Is Ideal for Bangalore Drivers',
  fourthdescription: 'Bangalore’s climate and road conditions can quickly affect your car’s appearance. Dust, pollution, monsoon splashes, and heat demand more than basic cleaning. Our car graphene coating in Bangalore provides a hydrophobic and anti-static layer that actively repels contaminants. This ensures long-lasting car paint protection coating, fewer washes, reduced scratches, and consistent shine—making it ideal for anyone searching for graphene coating services near me.',

  fivetitle: 'Exploring SPS Graphene Coating and Other Product Types',
  fivedescription: 'We use certified-grade materials, including advanced formulas comparable to SPS graphene coating, known for durability and clarity. Our premium graphene coating for cars solutions are engineered to match global standards while delivering excellent finish and protection. We also offer graphene detail spray options for maintenance between full professional graphene car detailing treatments.',

  sixtitle: 'Experience the Next Generation of Paint Protection',
  sixdescription: 'Graphene is the future of automotive surface protection. With exceptional resistance to heat, water, and contaminants, it provides unmatched durability and shine. Whether you are protecting a new car or restoring an older one, Drive-In Car Spa offers the best graphene coating for cars with advanced professional graphene car detailing. If you’re searching for graphene coating services near me, our Bangalore center is equipped to deliver premium results.',

  highlights: [
    'Full exterior wash and decontamination',
    'Surface prep with clay bar treatment',
    'Paint correction to remove swirl marks or oxidation',
    'Application of multi-layer graphene ceramic coating',
    'Final buffing for mirror-gloss finish',
    'Durability: 2–3 years',
    'Complimentary 10 automatic touchless washes post-application'
  ],

  faq: [
    {
      question: "What is the best graphene coating for cars in Bangalore?",
      answer: "The best graphene coating for cars combines durability, anti-static properties, and high gloss. At Drive-In Car Spa, we provide premium graphene coating for cars with professional graphene car detailing for long-lasting results."
    },
    {
      question: "Are graphene coating services near me worth it?",
      answer: "Yes, graphene coating services near me offer superior long-lasting car paint protection coating, better heat resistance, and reduced dust buildup compared to traditional coatings."
    },
    {
      question: "How long does graphene coating last?",
      answer: "Graphene coating typically lasts up to 2–3 years with proper maintenance, making it a reliable long-lasting car paint protection coating option."
    },
    {
      question: "Is graphene better than ceramic coating?",
      answer: "In many cases, yes. Premium graphene coating for cars provides better heat dissipation, anti-static performance, and durability compared to ceramic coatings."
    },
    {
      question: "Where can I get car graphene coating in Bangalore?",
      answer: "Drive-In Car Spa offers professional car graphene coating in Bangalore with advanced detailing, premium materials, and expert application."
    },
    {
      question: "Can I use graphene spray instead of full coating?",
      answer: "Graphene sprays are useful for maintenance, but they do not provide the same level of long-lasting car paint protection coating as a full professional graphene car detailing service."
    },
  ],

  pillLabel: 'Key Highlights',
  audience: 'All Car Owners',
},



 'borophene-coating': {
  hero: {
    title: (
      <>
        <span className="highlight">Borophene Coating for Cars – Next-Gen </span><br />
        Nano Protection for Your Vehicle
      </>
    ),
    subtitle: 'Revolutionary Protection with Borophene Coating',
    bgImage: banner4,
  },
  maintitle: 'Borophene Coating',
  title: 'Ultra-Light, Nano-Strong, and Future-Ready Paint Armor',

  description: <>At Drive-In Car Spa, we continuously invest in innovation to redefine vehicle protection. Our <Link to="/" className="link-text">best borophene coating for cars</Link> represents one of the most advanced breakthroughs in automotive detailing. This advanced borophene coating for vehicles is a high-performance, nanotechnology-based solution that combines extreme strength with ultra-light application. If you're looking for premium borophene coating services that offer durability, flexibility, and long-term performance, our nano borophene coating for car paint protection is engineered to deliver exactly that.</>,

  secondtitle: 'What Is Borophene Coating?',
  seconddescription: 'Borophene is a one-atom-thick layer of boron, classified among next-generation nanomaterials similar to graphene. Known for its exceptional tensile strength, flexibility, and conductivity, it forms the foundation of borophene paint protection for cars. When applied as a nano borophene coating for car paint protection, it creates an ultra-thin yet powerful protective layer. Compared to traditional coatings, this advanced borophene coating for vehicles adapts better to complex surfaces, making it ideal for modern car designs.',

  thirdtitle: 'Key Benefits of Nano Borophene Coating',
  thirddescription: 'Extremely strong yet ultra-light structure, Self-cleaning hydrophobic surface, High resistance to environmental damage, UV and heat resistance, Exceptional flexibility for better surface adaptation—making it a superior borophene paint protection for cars solution.',

  fourthtitle: 'Premium Paint Protection with Future-Proof Technology',
  fourthdescription: 'Your vehicle deserves more than temporary shine. Our car spa services with borophene coating deliver a super-hydrophobic, invisible protective layer that repels water, reduces scratches, and enhances overall finish. This premium borophene coating services solution combines scientific innovation with expert craftsmanship to ensure your car remains protected and visually stunning for the long term.',

  fivetitle: 'Book Your Nano Borophene Coating Today',
  fivedescription: 'If you are looking to invest in next-level surface protection, our nano borophene coating for car paint protection offers both structural strength and aesthetic enhancement. Drive-In Car Spa is among the few providers offering advanced borophene coating for vehicles in Bangalore, backed by trained professionals, high-quality materials, and customer-focused service.',

  sixtitle: 'Experience the Next Generation of Paint Protection',
  sixdescription: 'Borophene coating is shaping the future of automotive protection with its ultra-light, high-strength characteristics. Whether you are protecting a new vehicle or upgrading an existing one, our borophene paint protection for cars ensures durability, shine, and reduced maintenance. Experience premium borophene coating services designed for modern vehicles and demanding road conditions.',

  highlights: [
    'Exterior wash and surface decontamination',
    'Paint correction to remove oxidation and minor swirl marks',
    'Application of multi-layer nano borophene coating',
    'UV, chemical, and corrosion resistance',
    'Heat-dissipation finish for reduced surface temperature',
    'Complimentary 10 touchless car washes post-application',
    'Longevity: 18–24 months'
  ],

  faq: [
    {
      question: "What is the best borophene coating for cars?",
      answer: "The best borophene coating for cars combines durability, flexibility, and nano-level protection. Our premium borophene coating services provide advanced protection with long-lasting performance."
    },
    {
      question: "Is borophene coating better than ceramic or graphene?",
      answer: "Borophene coating offers superior flexibility and ultra-light protection. While ceramic and graphene focus on hardness, advanced borophene coating for vehicles excels in adaptability and modern surface protection."
    },
    {
      question: "How long does borophene coating last?",
      answer: "Typically between 18 to 24 months, depending on usage and maintenance. It is designed as a long-term nano borophene coating for car paint protection solution."
    },
    {
      question: "What are car spa services with borophene coating?",
      answer: "These services include complete detailing, paint correction, and application of borophene paint protection for cars to ensure a clean, protected, and glossy finish."
    },
    {
      question: "Is borophene coating available in Bangalore?",
      answer: "Yes, Drive-In Car Spa offers premium borophene coating services in Bangalore with expert application and high-quality materials."
    },
    {
      question: "Is borophene paint protection safe for all vehicles?",
      answer: "Yes, borophene paint protection for cars is suitable for all vehicle types including hatchbacks, sedans, SUVs, and luxury vehicles."
    },
  ],

  pillLabel: 'Key Highlights',
  audience: 'All Car Owners',
},


'paint-protection-film':  {
  hero: {
    title: (
      <>
        <span className="highlight">Paint Protection Film (PPF) for Cars – </span><br />
        Invisible Armor for Every Drive
      </>
    ),
    subtitle: 'Invisible Paint Defense with Self-Healing Power',
    bgImage: banner5,
  },

  maintitle: 'Paint Protection Films',
  title: 'Protect Your Paint. Preserve Your Shine. Drive with Confidence.',

  description: <>From city traffic and stone chips to daily parking scratches, your car's paint is always at risk. At Drive-In Car Spa, we offer <Link to="/" className="link-text">paint protection film</Link> solutions designed for maximum durability and clarity. Our premium PPF coating services include clear paint protection film installation that shields your vehicle from scratches, scuffs, and minor impacts without altering its appearance. Whether you're exploring PPF car coating price near me or need complete car PPF installation services, we deliver long-term protection with a seamless finish.</>,

  secondtitle: 'What Is Paint Protection Film (PPF)?',
  seconddescription: 'Paint Protection Film is a transparent, high-strength layer applied over your car’s exterior surfaces. This scratch protection film for cars uses advanced self-healing technology, allowing minor scratches to disappear with heat or sunlight. Ideal for those searching for clear paint protection film installation or PPF car near me, it protects against stone chips, road debris, swirl marks, bird droppings, UV rays, and everyday wear and tear.',

  thirdtitle: 'Key Benefits of PPF for Cars',
  thirddescription: 'Scratch & chip resistance, advanced scratch protection film for cars, stain & chemical resistance, UV protection, heat-activated self-healing surface, invisible finish, removable and replaceable layers for long-term use.',

  fourthtitle: 'Where Can PPF Be Applied?',
  fourthdescription: 'Our car PPF installation services are fully customizable based on your needs. We provide both partial and full-body clear paint protection film installation including door edges, bumpers, hood, mirrors, handles, trunk edges, headlights, and complete wraps for maximum coverage.',

  fivetitle: 'Invisible Protection. Long-Term Results.',
  fivedescription: 'Whether you are protecting a luxury vehicle, safeguarding your daily car, or preserving a brand-new purchase, our premium PPF coating services offer unmatched durability. This paint protection film solution ensures your car maintains its finish and resale value while resisting scratches, chips, and environmental damage.',

  sixtitle: 'Book Your PPF Installation Today',
  sixdescription: 'Drive-In Car Spa provides expert car PPF installation services in Bangalore, trusted by car owners and enthusiasts alike. If you are comparing PPF car coating price near me or looking for clear paint protection film installation, we offer transparent pricing, premium materials, and skilled technicians for reliable results.',

  highlights: [
    'Exterior wash and surface decontamination',
    'Paint correction to remove oxidation and minor swirl marks',
    'Precision clear paint protection film installation',
    'UV, chemical, and corrosion resistance',
    'Self-healing top layer technology',
    'Complimentary 10 touchless car washes post-application',
    'Longevity: 5–7 years depending on usage'
  ],

  faq: [
    {
      question: "What is paint protection film and how does it work?",
      answer: "Paint protection film is a transparent scratch protection film for cars that protects against chips, scratches, and environmental damage while maintaining your car’s original look."
    },
    {
      question: "What is the PPF car coating price near me in Bangalore?",
      answer: "PPF car coating price near me depends on coverage (partial or full-body), film quality, and vehicle type. We offer competitive pricing for premium PPF coating services."
    },
    {
      question: "How long does PPF last?",
      answer: "High-quality paint protection film typically lasts 5 to 7 years, depending on maintenance and driving conditions."
    },
    {
      question: "Is PPF better than ceramic coating?",
      answer: "Both serve different purposes. Paint protection film protects against physical damage, while ceramic coating enhances gloss and hydrophobic properties. Many customers combine both for complete protection."
    },
    {
      question: "Where can I get car PPF installation services near me?",
      answer: "Drive-In Car Spa offers professional car PPF installation services in Bangalore with expert technicians and premium materials."
    },
    {
      question: "Is clear paint protection film visible on the car?",
      answer: "No, clear paint protection film installation is designed to be nearly invisible while preserving the original color and finish of your vehicle."
    },
  ],

  pillLabel: 'Key Highlights',
  audience: 'All Car Owners',
},



'windshield-protection-film': {
  hero: {
    title: (
      <>
        <span className="highlight">Windshield Protection Film – Invisible Strength </span><br />
        for a Clearer, Safer Drive
      </>
    ),
    subtitle: 'Drive Safer with Windshield Protection Film',
    bgImage: banner6,
  },

  maintitle: 'Wind Protection Films',
  title: 'Prevent Cracks, Scratches & UV Damage with One Simple Upgrade',

  description: <>Your car’s front glass is one of its most vulnerable components, yet often overlooked. At Drive-In Car Spa, we offer <Link to="/" className="link-text">best car windshield protection film</Link> solutions designed to protect against chips, cracks, glare, and UV damage without affecting visibility. Whether you’re searching for windshield protection film near me or comparing car windshield protection film cost, our premium films provide long-term durability, clarity, and safety for everyday driving conditions.</>,

  secondtitle: 'Why You Need Windshield Protection Film',
  seconddescription: 'Most drivers only think about their windshield after damage occurs—but by then, repair costs can be high. Our windshield protection film acts as a proactive solution that shields your glass from impacts, reduces glare from sunlight and headlights, blocks harmful UV rays, and minimizes the need for repairs. It also improves scratch resistance and ensures long-lasting clarity, making it ideal for anyone searching for windshield protection film near me.',

  thirdtitle: 'What Our Windshield Protection Film Offers',
  thirddescription: 'Our advanced windshield protection film uses multi-layer polyurethane and nano-coating technology for enhanced performance. It is ultra-thin, optically clear, and built to handle real-world driving conditions. Key features include impact resistance, UV blocking, glare reduction, anti-shatter protection, optical clarity, and scratch-resistant durability—all contributing to optimized windshield protection film price value.',

  fourthtitle: 'Application Areas',
  fourthdescription: 'Our car windshield protection film is suitable for multiple vehicle types including sedans, SUVs, hatchbacks, luxury cars, and commercial vehicles. It is especially beneficial for high-mileage drivers, highway commuters, and anyone looking for windshield protection film near me with reliable performance and safety enhancement.',

  fivetitle: 'Why Choose Drive-In Car Spa?',
  fivedescription: 'Instead of searching repeatedly for windshield replacement solutions, invest in prevention. Our windshield protection film installation ensures precision fit, bubble-free application, and long-lasting adhesion. We use high-clarity materials with UV-stable properties, offering excellent value for windshield protection film price and reducing long-term maintenance costs.',

  sixtitle: 'Who Needs This Service Most?',
  sixdescription: 'Daily commuters exposed to road debris, fleet drivers with high usage, families needing UV protection, and car owners looking to avoid high car windshield protection film cost from repairs or replacements will benefit greatly from this service.',

  highlights: [
    'Impact Resistance',
    'UV Blocking',
    'Glare Reduction',
    'Anti-Shatter Layer',
    'Optical Clarity',
    'Scratch-Resistant'
  ],

  faq: [
    {
      question: "What is the best car windshield protection film?",
      answer: "The best car windshield protection film offers high impact resistance, UV protection, and optical clarity. Our films are designed for durability, safety, and long-term performance."
    },
    {
      question: "How much does windshield protection film cost?",
      answer: "Windshield protection film cost depends on vehicle type and film quality. We offer competitive windshield protection film price options with premium materials and expert installation."
    },
    {
      question: "Is windshield protection film available near me?",
      answer: "Yes, if you are searching for windshield protection film near me, Drive-In Car Spa provides professional installation services in Bangalore."
    },
    {
      question: "Will windshield protection film affect visibility?",
      answer: "No, our films are optically clear and do not interfere with visibility, sensors, or driving experience."
    },
    {
      question: "Can it prevent cracks completely?",
      answer: "While it cannot stop extreme impacts, it significantly reduces the chances of chips and cracks, helping avoid costly repairs."
    },
    {
      question: "Is windshield protection film worth the price?",
      answer: "Yes, considering the high cost of windshield replacement, investing in windshield protection film provides excellent long-term value and protection."
    },
  ],

  pillLabel: 'Key Highlights',
  audience: 'All Car Owners',
},


 'sprayable-ppf': {
  hero: {
    title: (
      <>
        <span className="highlight">Spray-On PPF – Seamless Paint  </span><br />
        Protection for Any Surface
      </>
    ),
    subtitle: 'Seamless, Edge-Free Paint Protection',
    bgImage: banner7,
  },

  maintitle: 'Sprayable PPF',
  title: 'No Edges. No Peeling. Just Pure, Unbroken Protection.',

  description: <>Traditional films offer excellent protection, but when it comes to curved panels, edges, and complex bodywork, they sometimes fall short. That’s where <Link to="/" className="link-text">sprayable paint protection film</Link> comes in. At Drive-In Car Spa, we use advanced paint protection film technology that bonds directly to your vehicle’s surface, delivering high-impact resistance, chemical protection, and a seamless, edge-free finish. Whether you're exploring the best PPF coating near me or modern alternatives to traditional films, this solution provides superior durability with the sleek appearance of paint rather than visible film.</>,

  secondtitle: 'What Is Spray-On PPF?',
  seconddescription: 'Sprayable paint protection film, also known as liquid polyurethane or peelable spray paint, is applied in liquid form and cured to create a flexible yet strong protective layer. It offers the same benefits as traditional paint protection film, including resistance to scratches, UV rays, and stone chips—without seams or visible edges. This makes it ideal for complex surfaces and full-body applications.',

  thirdtitle: 'Why Choose Spray-On Over Traditional PPF?',
  thirddescription: 'Perfect for covering curves, vents, and intricate designs, Seamless application with no visible edges or joints, Eliminates risks of peeling or bubbling, Can be paired with ceramic coating for enhanced gloss and durability, Ideal alternative when searching for best PPF coating near me.',

  fourthtitle: 'Benefits of Spray-On PPF',
  fourthdescription: 'When combined with advanced detailing solutions or services from an automatic car washing centre, sprayable paint protection film delivers maximum performance: Self-healing surface for minor scratches, Strong UV resistance, High impact protection, Gloss or matte finish options, Chemical resistance against environmental damage.',

  fivetitle: 'Application Process – How We Apply Spray-On PPF',
  fivedescription: 'Our professional process ensures a flawless finish: Deep wash & decontamination, paint correction, spray coating application, curing process, optional top coat, and final inspection. This structured approach guarantees long-lasting performance and premium protection.',

  sixtitle: 'Protect Without Compromise',
  sixdescription: 'If you want advanced protection without visible film edges, sprayable paint protection film is the perfect solution. Whether you’re upgrading from traditional paint protection film or exploring modern options like peelable spray paint, this technology delivers seamless protection that becomes part of your vehicle’s surface.',

  highlights: [
    'Deep Wash & Decontamination',
    'Paint Correction',
    'Spray Coating',
    'Curing',
    'Top Coat (Optional)',
    'Final Inspection'
  ],

  faq: [
    {
      question: "What is sprayable paint protection film?",
      answer: "Sprayable paint protection film is a liquid-applied protective coating that forms a durable, flexible layer over your car’s paint, offering protection similar to traditional paint protection film but without seams."
    },
    {
      question: "Is peelable spray paint the same as spray-on PPF?",
      answer: "Peelable spray paint offers temporary protection, while sprayable paint protection film is more durable, long-lasting, and designed for high-performance automotive protection."
    },
    {
      question: "How long does spray-on PPF last?",
      answer: "With proper maintenance, sprayable paint protection film can last several years, providing reliable protection against scratches, UV rays, and environmental damage."
    },
    {
      question: "Is this better than traditional PPF?",
      answer: "It depends on your needs. Sprayable paint protection film is better for seamless coverage and complex surfaces, while traditional PPF may be preferred for specific high-impact zones."
    },
    {
      question: "Where can I find the best PPF coating near me?",
      answer: "Drive-In Car Spa offers advanced spray-on and traditional paint protection film services in Bangalore, delivering high-quality results with professional application."
    },
    {
      question: "Can I maintain it at an automatic car washing centre?",
      answer: "Yes, sprayable paint protection film is designed to withstand regular washing, including services at an automatic car washing centre, without losing its protective properties."
    },
  ],

  pillLabel: 'Key Highlights',
  audience: 'All Car Owners',
},


  'detailing-services': {
  hero: {
    title: (
      <>
        <span className="highlight">Car Detailing – Complete Care,  </span><br />
        Inside and Out
      </>
    ),
    subtitle: 'Seamless, Edge-Free Paint Protection',
    bgImage: banner8,
  },

  maintitle: 'Professional Car Detailing for a Showroom Finish',
  title: 'Precision Detailing to Restore, Refresh & Protect',

  description: <>Sometimes, a basic wash isn’t enough. Over time, your vehicle develops swirl marks, stains, fading trims, and buildup that regular cleaning cannot fix. That’s where <Link to="/" className="link-text">top detailed car washing near me</Link> solutions come in. At Drive-In Car Spa, we provide professional car detailing Bengaluru services that go beyond surface cleaning—focusing on restoration, protection, and long-term maintenance. Whether you're preparing your car for resale or simply want a showroom finish, our expert team delivers premium results.</>,

  secondtitle: 'What Is Car Detailing?',
  seconddescription: 'If you’re searching for full service car cleaning near me or detailed car washing near me, our comprehensive detailing service is designed for complete care. It includes deep cleaning and restoration of both interior and exterior: paint correction to remove swirls and oxidation, trim and headlight restoration, engine bay cleaning, seat shampooing, dashboard polishing, and protective coatings for long-lasting shine.',

  thirdtitle: 'Why Choose Drive-In Car Spa for Car Detailing?',
  thirddescription: 'Our car detailing Bengaluru service stands out with trained technicians, paint-safe tools, eco-friendly processes, and high-quality products. Whether you’re looking for detailed car washing near me or a premium detailing package, we ensure consistent results with transparent pricing and no hidden costs.',

  fourthtitle: 'Ideal For',
  fourthdescription: 'Vehicles with dull or scratched paint, interiors with stains or odors, owners searching for full service car cleaning near me with professional results, resale preparation, and those looking for regular maintenance beyond a drive-in car wash near me.',

  fivetitle: 'Looking for "Complete Car Cleaning Near Me"? You Found It.',
  fivedescription: 'Many customers discover us while searching for full service car cleaning near me or detailed car washing near me. Our services go beyond a typical drive-in car wash near me by focusing on correction, polishing, and preservation—not just cleaning.',

  sixtitle: 'Complete Car Detailing Near Me – With Results You Can See',
  sixdescription: 'If you’re searching for complete car detailing near me or reliable car detailing Bengaluru services, Drive-In Car Spa delivers visible transformation. Our expert detailing process ensures your vehicle looks refreshed, protected, and showroom-ready.',

  highlights: [
    'Paint & plastic polishing',
    'Engine bay cleaning',
    'Interior vacuuming & dashboard restoration',
    'Leather & chrome conditioning',
    'Pre-sale and showroom prep'
  ],

  faq: [
    {
      question: "What is the best detailed car washing near me?",
      answer: "The best detailed car washing near me includes deep cleaning, paint correction, and interior restoration. Our professional car detailing Bengaluru service delivers complete vehicle care."
    },
    {
      question: "What does full service car cleaning include?",
      answer: "Full service car cleaning near me includes interior vacuuming, seat shampooing, dashboard cleaning, exterior polishing, and protective treatments for long-lasting results."
    },
    {
      question: "How is detailing different from a regular car wash?",
      answer: "A regular wash removes surface dirt, while detailing focuses on deep cleaning, restoration, and protection—making your car look and feel like new."
    },
    {
      question: "Where can I find car detailing Bengaluru services?",
      answer: "Drive-In Car Spa offers professional car detailing Bengaluru services with expert technicians and advanced tools for premium results."
    },
    {
      question: "How often should I get my car detailed?",
      answer: "It is recommended every 4–6 months depending on usage and conditions to maintain your car’s appearance and value."
    },
    {
      question: "Is detailing better than a drive-in car wash near me?",
      answer: "Yes, detailing provides deeper cleaning, restoration, and protection compared to a standard drive-in car wash near me, which focuses only on surface cleaning."
    },
  ],

  pillLabel: 'Key Highlights',
  audience: 'All Car Owners',
},


'deep-interior-cleaning': {
  hero: {
    title: (
      <>
        <span className="highlight">Sanitized, Stain-Free & </span><br />
        Odor-Free Interiors 
      </>
    ),
    subtitle: 'Breathe Easy with Deep Interior Cleaning',
    bgImage: banner9,
  },

  maintitle: 'Deep Interior Car Cleaning – A Healthier, Fresher Cabin Starts Here',
  title: 'Eliminate Hidden Soil, Marks, and Smells using Advanced Interior Cleaning.',

  description: <>No matter how clean your car looks from the outside, the interior often hides dirt, bacteria, and allergens deep within seats, vents, and carpets. That’s why our <Link to="/" className="link-text">best car interior cleaning in Bangalore</Link> service focuses on deep sanitation and restoration. At Drive-In Car Spa, we provide professional car interior cleaning services designed to remove stains, eliminate odors, and restore freshness—making your cabin healthier, cleaner, and more comfortable for everyday driving.</>,

  secondtitle: 'What Is Deep Interior Cleaning for Cars?',
  seconddescription: 'Unlike basic vacuuming or wiping, deep interior cleaning services go beyond the surface. If you’re searching for car interior cleaning near me, our service includes removal of bacteria, allergens, and dust mites, deep cleaning car seats and upholstery, stain removal from fabric and leather, odor neutralization from food, moisture, or smoke, and detailed cleaning of hard-to-reach areas like AC vents, seat rails, and door pockets.',

  thirdtitle: 'Why Choose Drive-In Car Spa for Interior Cleaning?',
  thirddescription: 'We offer professional car cleaning services in Bangalore using eco-safe products that are safe for kids and pets. Our process ensures fast drying, minimal moisture retention, and zero mold risk. With trained experts handling leather, fabric, and delicate surfaces, we deliver the best car interior cleaning in Bangalore trusted by thousands of customers.',

  fourthtitle: 'Deep Inside Car Cleaning – Who Needs It Most?',
  fourthdescription: 'You should consider car interior cleaning near me if you own a pre-owned vehicle, have kids or pets, frequently eat or smoke in your car, or notice stains, odors, or sticky surfaces. It is also ideal before resale or if your vehicle is exposed to dust-heavy environments in Bangalore.',

  fivetitle: 'Car Interior Cleaning Near Me – We\'re Worth the Drive',
  fivedescription: 'If you are searching for reliable car interior cleaning services or complete car cleaning services in Bangalore, Drive-In Car Spa offers unmatched quality. Unlike a basic express automatic car wash, our deep cleaning process focuses on hygiene, detailing, and long-term freshness.',

  highlights: [
    'Vacuuming of carpets, seats, and trunk',
    'Deep upholstery and seat cleaning',
    'Dashboard, console, and door panel restoration',
    'Interior glass cleaning',
    'Floor mat wash and odor removal',
    'Advanced deep interior sanitation'
  ],

  faq: [
    {
      question: "What is included in car interior cleaning services?",
      answer: "Car interior cleaning services include vacuuming, seat shampooing, stain removal, odor elimination, dashboard cleaning, and deep sanitation of all interior surfaces."
    },
    {
      question: "Where can I find the best car interior cleaning in Bangalore?",
      answer: "Drive-In Car Spa provides the best car interior cleaning in Bangalore with advanced equipment, trained professionals, and high-quality products."
    },
    {
      question: "How often should I get car interior cleaning done?",
      answer: "It is recommended every 3–6 months depending on usage, especially if you drive daily or have kids, pets, or food spills inside the car."
    },
    {
      question: "Is interior cleaning better than an express automatic car wash?",
      answer: "Yes, an express automatic car wash only cleans the exterior, while deep interior cleaning services focus on hygiene, stain removal, and odor control inside the car."
    },
    {
      question: "Do you offer car interior cleaning near me?",
      answer: "Yes, Drive-In Car Spa offers professional car interior cleaning near me services in Bangalore with complete detailing and sanitation."
    },
    {
      question: "Does deep cleaning remove bad odors completely?",
      answer: "Yes, our process neutralizes odors caused by food, smoke, moisture, and bacteria, leaving your car fresh and hygienic."
    },
  ],

  pillLabel: 'Key Highlights',
  audience: 'All Car Owners',
},


 'steam-wash': {
  hero: {
    title: (
      <>
        <span className="highlight">Car Steam Cleaning – Deep Clean </span><br />
        Without the Chemicals
      </>
    ),
    subtitle: 'Eco-Friendly Steam Wash for Gentle Deep Cleaning',
    bgImage: banner10,
  },

  maintitle: 'Steam Wash',
  title: 'Eco-Friendly, Contactless, and Safe for Every Surface',

  description: <>Drive-In Car Spa offers <Link to="/" className="link-text">best steam car wash</Link> solutions designed for deep, eco-friendly cleaning—both inside and outside your vehicle. Steam car wash cleaning is a smarter, safer alternative to traditional methods, using high-temperature vapor to remove dirt, sanitize surfaces, and reach areas inaccessible with regular tools. Whether it’s dusty dashboards, sticky seat gaps, or greasy engine areas, our steam-based process delivers a thorough clean without chemical damage or water runoff, making it ideal for those searching for steam car wash services near me.</>,

  secondtitle: 'Why Choose Steam Cleaning for Cars?',
  seconddescription: 'Steam car wash cleaning uses high-temperature vapor to break down dirt, grease, and bacteria without harsh chemicals. If you’re looking for steam car wash services near me or popular steam car washing services, our facility provides professional-grade equipment and trained experts to deliver: Kills 99.9% of bacteria and germs, Eco-friendly and water-saving process, Safe for all interior materials, No chemical residue, Ideal for detailing and sanitization.',

  thirdtitle: 'Why Choose Drive-In Car Spa for Steam Cleaning?',
  thirddescription: 'We provide popular steam car washing services using advanced equipment and eco-safe processes. Our trained technicians ensure safe cleaning for leather, fabric, and delicate surfaces while maintaining fast drying and minimal moisture retention. This makes us a preferred choice for anyone searching for the best steam car wash in Bangalore.',

  fourthtitle: 'Book Your Car Steam Wash Today',
  fourthdescription: 'Whether you are searching for steam car wash services near me, eco-friendly steam car wash cleaning, or reliable popular steam car washing services, Drive-In Car Spa offers a modern solution that prioritizes safety, hygiene, and efficiency. Steam proves that deep cleaning doesn’t have to be harsh.',

  highlights: [
    'Seat steaming (fabric or leather-safe)',
    'AC vent and dashboard disinfection',
    'Door handles, window switches, and buttons cleaning',
    'Steam cleaner for car detailing',
    'Odor neutralization',
    'Full body panel cleaning using high-temperature vapor',
    'Wheel arches, alloys, and engine bay steaming',
    'Waterless wipe-down with microfiber cloths',
    'Safe for all paint types and coatings, including ceramic'
  ],

  faq: [
    {
      question: "What is the best steam car wash service near me?",
      answer: "The best steam car wash services near me use high-temperature steam for deep cleaning, sanitization, and eco-friendly results without damaging your vehicle surfaces."
    },
    {
      question: "Is steam car wash cleaning safe for interiors?",
      answer: "Yes, steam car wash cleaning is safe for leather, fabric, and dashboards. It cleans deeply without chemicals and preserves material quality."
    },
    {
      question: "How often should I get a steam car wash?",
      answer: "It is recommended every 4–6 weeks for interiors and more frequently for heavy usage vehicles to maintain hygiene and cleanliness."
    },
    {
      question: "Is steam cleaning better than a regular car wash?",
      answer: "Steam cleaning offers deeper sanitization, uses less water, and avoids harsh chemicals, making it a safer and more eco-friendly alternative."
    },
    {
      question: "Are steam car wash services available near me in Bangalore?",
      answer: "Yes, Drive-In Car Spa provides popular steam car washing services in Bangalore with professional equipment and trained staff."
    },
    {
      question: "Does steam cleaning remove odors and bacteria?",
      answer: "Yes, high-temperature steam effectively removes bacteria, germs, and odor-causing particles, leaving your car fresh and sanitized."
    },
  ],

  pillLabel: 'Key Highlights',
  audience: 'All Car Owners',
},



'bike-detailing': {
  hero: {
    title: (
      <>
        <span className="highlight">Bike Detailing – Premium Care</span><br />
        for Your Two-Wheeler
      </>
    ),
    subtitle: 'Get Your Bike Gleaming Like Brand New',
    bgImage: banner11,
  },

  maintitle: 'Bike Detailing',
  title: 'Precision Cleaning, Coating & Polishing for Bikes and Scooters',

  description: <>Your bike deserves more than just a rinse. Whether you ride daily or occasionally, proper detailing helps maintain performance, appearance, and resale value. At Drive-In Car Spa, we offer <Link to="/" className="link-text">best bike detailing services</Link> tailored for motorcycles and scooters. From chrome polishing to ceramic coating for bike near me, our premium bike wash services are designed to protect, enhance, and preserve your two-wheeler’s finish.</>,

  secondtitle: 'Why Bike Detailing Matters?',
  seconddescription: 'Two-wheelers are constantly exposed to dust, grease, fuel spills, heat, and rain, leading to fading, corrosion, and dull paint. Our bike detailing Bengaluru service ensures deep cleaning, restoration, and protection. Whether you are searching for full bike washing near me or advanced coating services, detailing helps extend your bike’s lifespan and maintain its visual appeal.',

  thirdtitle: 'Best Bike Polish for Matte Finish',
  thirddescription: 'Matte-finish bikes require specialized care. Using regular polish can damage their texture and appearance. That’s why we use the best bike polish for matte finish to maintain the non-glossy look, provide UV and heat resistance, repel dust and water, and preserve the original matte finish without streaks or shine.',

  fourthtitle: 'Motorcycle Detailing Near Me – With Results You Can See',
  fourthdescription: 'If you are searching for bike detailing Bengaluru or full bike washing near me, Drive-In Car Spa delivers precision-driven services. From commuter scooters to premium motorcycles, our premium bike wash services ensure showroom-level results with professional tools and techniques.',

  highlights: [
    'Exterior & chrome cleaning',
    'Paint surface preparation & coating',
    'Seat, handle, and grip cleaning',
    'Engine area degreasing',
    'Protective polish and finishing'
  ],

  faq: [
    {
      question: "What are the best bike detailing services in Bangalore?",
      answer: "The best bike detailing services include deep cleaning, polishing, and protective coatings. Drive-In Car Spa offers professional bike detailing Bengaluru services for all types of motorcycles."
    },
    {
      question: "Do you offer ceramic coating for bikes near me?",
      answer: "Yes, we provide ceramic coating for bike near me services that offer long-lasting protection against UV rays, dirt, and environmental damage."
    },
    {
      question: "How often should I get my bike detailed?",
      answer: "It is recommended every 2–4 months depending on usage and exposure to dust, rain, and road conditions."
    },
    {
      question: "What is included in premium bike wash services?",
      answer: "Premium bike wash services include deep cleaning, degreasing, polishing, and protective coating for enhanced durability and shine."
    },
    {
      question: "Is bike detailing better than a regular bike wash?",
      answer: "Yes, detailing goes beyond basic cleaning by restoring paint, protecting surfaces, and improving overall appearance and longevity."
    },
    {
      question: "Where can I find full bike washing near me?",
      answer: "Drive-In Car Spa offers full bike washing near me services in Bangalore with professional-grade equipment and expert care."
    },
  ],

  pillLabel: 'Key Highlights',
  audience: 'All Car Owners',
},


  'window-films':{
  hero: {
    title: (
      <>
        <span className="highlight">Car Window Tinting & Film – Style, Privacy, </span><br />
        and UV Protection in One Layer
      </>
    ),
    subtitle: 'Tinted Comfort with Premium Window Films',
    bgImage: banner12,
  },

  maintitle: 'Window Films',
  title: 'Drive Cooler, Safer, and Smarter with High-Quality Window Films',

  description: <>The sun in Bangalore isn’t just harsh—it can damage interiors, overheat your cabin, and reduce driving comfort. At Drive-In Car Spa, we offer <Link to="/" className="link-text">best window film services</Link> designed to provide heat rejection, UV protection, and enhanced privacy. Our premium window film services go beyond basic tinting, delivering long-lasting performance and a refined look while maintaining legal visibility standards. Whether you're searching for the car wash near me with detailing support or complete car wash detailing in Bangalore, our window film solutions complement your vehicle care perfectly.</>,

  secondtitle: 'Why Tint Your Car Windows?',
  seconddescription: 'Window tinting is not just about style—it’s about comfort and protection. If you’re comparing premium window film services or exploring affordable options, our films offer heat rejection, UV protection, glare reduction, privacy enhancement, and improved vehicle aesthetics. This makes them an essential upgrade for Bangalore driving conditions.',

  thirdtitle: 'Legal & Safety Considerations',
  thirddescription: 'Our window films comply with RTO regulations, ensuring legal visibility limits. We guide you on correct tint levels, windshield and rear window compliance, and safe installation practices so you stay within legal limits while enjoying maximum benefits.',

  fourthtitle: 'Car Window Tint Near Me – Clean Installs, Guaranteed Quality',
  fourthdescription: 'If you are searching for premium window film services or the car wash near me with professional installation, Drive-In Car Spa ensures precision application with bubble-free finishing. Our installations deliver durability, clarity, and enhanced privacy without compromising visibility or performance.',

  highlights: [
    'Dyed films (budget-friendly)',
    'Metalized films',
    'Carbon & ceramic films (premium)'
  ],

  faq: [
    {
      question: "What are the best window film services in Bangalore?",
      answer: "The best window film services include high-quality installation, UV protection, heat rejection, and long-lasting durability. Drive-In Car Spa offers premium window film services tailored for Bangalore conditions."
    },
    {
      question: "Is car window tinting legal in India?",
      answer: "Yes, as long as it meets RTO guidelines—typically 70% visibility for front windows and 50% for rear sides. We provide compliant options."
    },
    {
      question: "How long do window films last?",
      answer: "High-quality films can last 3–5 years or more depending on usage and maintenance."
    },
    {
      question: "What is the cost of window film services?",
      answer: "Costs depend on film type and vehicle size. We offer both budget and premium window film services with transparent pricing."
    },
    {
      question: "Where can I find car wash detailing in Bangalore with window tinting?",
      answer: "Drive-In Car Spa provides car wash detailing in Bangalore along with professional window film installation services."
    },
    {
      question: "Do window films reduce heat and UV exposure?",
      answer: "Yes, premium window films significantly reduce cabin heat and block harmful UV rays, improving comfort and protecting interiors."
    },
  ],

  pillLabel: 'Key Highlights',
  audience: 'All Car Owners',
},


'painting-denting-services': {
  hero: {
    title: (
      <>
        <span className="highlight">Dent Removal & Car Paint Repair Services - </span><br />
        Restore Your Car's Original Finish
      </>
    ),
    subtitle: 'Restore Your Car\'s Original Beauty',
    bgImage: banner13,
  },

  maintitle: 'Painting & Denting Services',
  title: 'Erase Dents, Scratches & Scrapes with Precision Paint Restoration',

  description: <>Even the most careful drivers deal with dents, scratches, and paint damage over time. At Drive-In Car Spa, we offer <Link to="/" className="link-text">best car denting and painting in Bangalore</Link> services designed to restore your vehicle’s original finish. Whether it’s minor dent removal, paintless dent repair, or full panel repainting, our expert team delivers precise results using advanced tools and techniques. If you are searching for car denting and painting near me, we provide professional solutions that bring back your car’s showroom look without unnecessary replacements.</>,

  secondtitle: 'What Causes Small Dents & Paint Damage?',
  seconddescription: 'Everyday driving conditions can lead to dents and scratches, including parking mishaps, door dings, minor collisions, road debris, and sun-related paint fading. Our car denting and painting in Bangalore services are designed to address these issues efficiently and restore your car’s appearance.',

  thirdtitle: 'Why Choose Us for Dent & Paint Services?',
  thirddescription: 'We specialize in car denting and painting in Bangalore with computer-matched paint blending, long-lasting finishes, eco-friendly materials, and minimal overspray. Our services can also be combined with detailing or coating for enhanced protection and shine.',

  fourthtitle: 'Minor Dent Removal Near Me – Trusted by Car Owners Across Bangalore',
  fourthdescription: 'If you are searching for car denting and painting near me or detailed car cleaning near me after repairs, Drive-In Car Spa offers complete restoration solutions. From small dents to paint touch-ups, we ensure your vehicle looks flawless without visible repair marks.',

  highlights: [
    'Minor dent removal',
    'Car paint repair & touch-ups',
    'Panel repainting & bumper repair',
    'Scratch and scuff removal',
    'Color matching and finishing'
  ],

  faq: [
    {
      question: "What is included in car denting and painting services?",
      answer: "Car denting and painting services include dent removal, paint correction, scratch repair, panel repainting, and finishing for a seamless look."
    },
    {
      question: "Where can I find the best car denting and painting in Bangalore?",
      answer: "Drive-In Car Spa offers the best car denting and painting in Bangalore with expert technicians, advanced tools, and high-quality materials."
    },
    {
      question: "How long does dent and paint repair take?",
      answer: "Minor dent repairs can take a few hours, while full paint jobs may require a day depending on the damage and curing process."
    },
    {
      question: "Will the new paint match my car perfectly?",
      answer: "Yes, we use computer-based color matching to ensure a seamless finish that blends perfectly with your car’s original paint."
    },
    {
      question: "Do you offer car denting and painting near me?",
      answer: "Yes, we provide car denting and painting near me services in Bangalore with reliable and professional results."
    },
    {
      question: "Can I combine denting services with detailing?",
      answer: "Absolutely. Many customers combine denting services with detailed car cleaning near me to achieve a complete restoration and polished finish."
    },
  ],

  pillLabel: 'Key Highlights',
  audience: 'All Car Owners',
},

'car-modifications':{
  hero: {
    title: (
      <>
        <span className="highlight">Car Modification & Customization – </span><br />
        Precision Upgrades, Legally Compliant
      </>
    ),
    subtitle: 'Personalize Your Ride with Premium Mods',
    bgImage: banner14,
  },

  maintitle: 'Car Modifications',
  title: 'Enhance Looks, Power, and Comfort — All in One Place',

  description: <>Thinking beyond factory settings? Drive-In Car Spa offers <Link to="/" className="link-text">best car modification near me</Link> solutions in Bangalore, delivering fully customized upgrades tailored to your needs. From interior and exterior car customization to performance enhancements, our expert team ensures every modification is safe, legal, and built to last. Whether you're exploring car modification services in India or upgrading a premium car in Bengaluru, we provide precision-driven results with high-quality materials and expert craftsmanship.</>,

  secondtitle: 'Why Choose Drive-In Car Spa for Custom Mods?',
  seconddescription: 'If you are searching for reliable car modification services in India, our approach focuses on safety, compliance, and performance. We offer expert guidance on RTO regulations, use the best car accessories in India, and ensure a perfect balance between aesthetics and functionality. Our services are designed for Indian road conditions and cover everything from concept to final execution.',

  thirdtitle: 'Who Are Our Mod Services For?',
  thirddescription: 'Our services are ideal for enthusiasts looking to personalize their vehicles, daily drivers wanting comfort upgrades, and owners of premium cars in Bengaluru seeking high-end customization. Whether subtle or bold, we deliver tailored solutions that enhance both performance and appearance.',

  fourthtitle: 'Custom Car Mods, Certified in Bangalore',
  fourthdescription: 'We specialize in interior and exterior car customization with a focus on safety compliance and durability. From visual enhancements to functional upgrades, our team ensures your vehicle stands out while maintaining road legality and performance standards.',

  highlights: [
    'Exterior modifications (body kits, wraps, lighting)',
    'Interior customization (ambient lighting, upholstery upgrades)',
    'Performance tuning & tech upgrades',
    'Installation of best car accessories in India',
    'Custom styling for premium cars in Bengaluru'
  ],

  faq: [
    {
      question: "What are the best car modification services near me?",
      answer: "The best car modification services near me include safe, legal upgrades for performance, aesthetics, and comfort. Drive-In Car Spa offers expert customization solutions in Bangalore."
    },
    {
      question: "Are car modifications legal in India?",
      answer: "Yes, but they must comply with RTO regulations. We guide you on legal modifications to ensure safety and compliance."
    },
    {
      question: "What types of car modifications do you offer?",
      answer: "We provide interior and exterior car customization, performance upgrades, lighting modifications, and installation of premium accessories."
    },
    {
      question: "Do you provide car modification services in India for all vehicles?",
      answer: "Yes, our services cover hatchbacks, sedans, SUVs, and premium cars in Bengaluru with customized solutions."
    },
    {
      question: "What is the cost of car modification?",
      answer: "Costs vary depending on the type of modification, materials used, and vehicle model. We provide transparent pricing based on your requirements."
    },
    {
      question: "Where can I find the best car accessories in India?",
      answer: "Drive-In Car Spa offers high-quality accessories and customization solutions using some of the best car accessories in India."
    },
  ],

  pillLabel: 'Key Highlights',
  audience: 'All Car Owners',
},
};

const SubServicePage = () => {
  const { serviceSlug } = useParams();
  const navigate = useNavigate();
  const service = serviceData[serviceSlug];
  const meta = serviceMeta[serviceSlug] || {
    title: "Service | DriveIn",
    description: "Learn more about our premium car services.",
    keywords: "car services, drivein, car care, auto services, vehicle maintenance"
  };

  if (!service) {
    return <div style={{ padding: '48px', textAlign: 'center' }}><h2>Service Not Found</h2></div>;
  }

  const handleServicesClick = () => {
    navigate('/service');
  };

  return (
    <>
      <Helmet>
        <title>{meta.title}</title>
        <meta name="description" content={meta.description} />
        <meta name="keywords" content={meta.keywords} />
        <link rel="canonical" href={`https://driveincarspa.com/services/${serviceSlug}`} />
        {/* Add more meta tags as needed */}
      </Helmet>
      <Hero
          title={service.hero.title}
          subtitle={service.hero.subtitle}
          bgImage={service.hero.bgImage}
          buttonText={service.hero.buttonText}
           onButtonClick={handleServicesClick}
        />
  <SubServiceHero
    maintitle={service.maintitle}
        title={service.title}
        description={service.description}
        secondtitle={service.secondtitle}
        seconddescription={service.seconddescription}
        thirdtitle={service.thirdtitle}
        thirddescription={service.thirddescription}
        fourthtitle={service.fourthtitle}
        fourthdescription={service.fourthdescription}
        fivetitle={service.fivetitle}
        fivedescription={service.fivedescription}
        sixtitle={service.sixtitle}
        sixdescription={service.sixdescription}
        highlights={service.highlights}
        audience={service.audience}
        pillLabel={service.pillLabel || "Key Highlights"}
      />
      <OurWorks/>
      {service.faq && <FaqSection faq={service.faq} />}
      <MembershipQuoteForm/>
     
    </>
  );
};

export default SubServicePage; 